import common from "./common";
import errors from "./errors";
import logs from "./logs";
import organizations from "./organizations";
import resellers from "./resellers";
import users from "./users";
import roles from "./roles";
import permissions from "./permissions";
import products from "./products";
import invoices from "./invoices";
import customers from "./customers";
import packages from "./packages";
import subscriptions from "./subscriptions";
import payments from "./payments";
import profile from "./profile";
import contacts from "@/i18n/en/contacts";
import suppliers from "@/i18n/en/suppliers";
import cafeterias from "./cafeterias";
import establishments from "./establishments";
import servicecenters from "./serviceCenters";
import imports from "@/i18n/en/imports";
import supplyRules from "./supplyRules";
import weeklyReports from "./weeklyReports";
import purchasesOrders from "./purchasesOrders";
import cashRegisterReadings from "./cashRegisterReadings";
import cashRegisterReadingsReport from "./cashRegisterReadingsReport";
import weeklyReportsReport from "./weeklyReportsReport";
import posProductsReport from "./posProductsReport";
import files from "./files";
import establishmentTransfers from "./establishmentTransfers";
import equipmentTransfers from "./equipmentTransfers";
import establishmentInternalInvoices from "./establishmentInternalInvoices";
import establishmentInternalOrders from "./establishmentInternalOrders";
import internalDocuments from "./internalDocuments";
import validation from "./validation";
import specialOrderReservations from "./specialOrderReservations";
import salesOrders from "./salesOrders";
import trainings from "./trainings";

export default {
  COMMON: common,
  ERRORS: errors,
  LOGS: logs,
  USERS: users,
  ORGANIZATIONS: organizations,
  RESELLERS: resellers,
  ROLES: roles,
  PERMISSIONS: permissions,
  PRODUCTS: products,
  INVOICES: invoices,
  CUSTOMERS: customers,
  SUBSCRIPTIONS: subscriptions,
  PACKAGES: packages,
  PAYMENTS: payments,
  PROFILE: profile,
  CONTACTS: contacts,
  SUPPLIERS: suppliers,
  CAFETERIAS: cafeterias,
  ESTABLISHMENTS: establishments,
  SERVICECENTERS: servicecenters,
  IMPORTS: imports,
  SUPPLY_RULES: supplyRules,
  WEEKLY_REPORTS: weeklyReports,
  PURCHASES_ORDERS: purchasesOrders,
  CASH_REGISTER_READINGS: cashRegisterReadings,
  CASH_REGISTER_READINGS_REPORT: cashRegisterReadingsReport,
  WEEKLY_REPORTS_REPORT: weeklyReportsReport,
  POS_PRODUCTS_REPORT: posProductsReport,
  FILES: files,
  ESTABLISHMENT_TRANSFERS: establishmentTransfers,
  EQUIPMENT_TRANSFERS: equipmentTransfers,
  ESTABLISHMENT_INTERNAL_INVOICES: establishmentInternalInvoices,
  ESTABLISHMENT_INTERNAL_ORDERS: establishmentInternalOrders,
  INTERNAL_DOCUMENTS: internalDocuments,
  VALIDATION: validation,
  SPECIAL_ORDER_RESERVATIONS: specialOrderReservations,
  SALES_ORDERS: salesOrders,
  TRAININGS: trainings,
};
